<div class="tab-pane" role="tabpanel" id="antecedentes_edif">
    <fieldset id="agregar_antecedentes_edif" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <form [formGroup]="form">
                        <h3 class="form-signin-heading"><strong>Antecedentes de la Edificacion</strong></h3>
                        <hr />
                        <div class="form-horizontal">
                            <div class="form-group" style="padding-bottom: 15px">
                                <label for="edificacion_antigua" class="col-md-4"  align="left">Solicitud trata de la regularizacion de Toda la Edificacion Antigua(<span style="color:red; font-size: 17px">*</span>)</label>
                                <div class="col-sm-3">
                                    <mat-radio-group formControlName="edificacion_antigua" style="padding-top: 4px">
                                        <mat-radio-button style="padding-right: 20px" name="edificacion_antigua" value="SI">SI</mat-radio-button>
                                        <mat-radio-button style="padding-right: 20px" name="edificacion_antigua" value="NO">NO</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>
                            <div class="form-group" style="padding-bottom: 15px">
                                <label for="ampliacion_antigua" class="col-md-4" align="left">Solicitud trata de la regularizacion de una Ampliacion Antigua(<span style="color:red; font-size: 17px">*</span>)</label>
                                <div class="col-sm-3">
                                    <mat-radio-group formControlName="ampliacion_antigua" style="padding-top: 4px">
                                        <mat-radio-button style="padding-right: 20px" name="ampliacion_antigua" value="SI">SI</mat-radio-button>
                                        <mat-radio-button style="padding-right: 20px" name="ampliacion_antigua" value="NO">NO</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>

                            <div class="form-group" align="left">
                                <div class="col-md-3">
                                    <label for="destino" style="padding-bottom: 20px; padding-top: 15px;">Destino Principal</label>
                                </div>
                                <div class="col-md-3">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Destino" id="destino" name="destino" formControlName="destino" >
                                    </mat-form-field>
                                </div>
                                <div class="col-md-3">
                                    <label class="control-label" for="superf_total" style="padding-bottom: 20px; padding-top: 15px;">Superficie Total a Regularizar</label>
                                </div>
                                <div class="col-md-3">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Superficie Total" id="superf_total" name="superf_total" formControlName="superf_total" >
                                        <span matSuffix>m²</span>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="form-group" align="left">
                                <div class="col-md-3">
                                    <label class="control-label" for="superf_terreno" style="padding-bottom: 20px; padding-top: 15px;">Superficie Terreno</label>
                                </div>
                                <div class="col-md-3">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Superficie Terreno" id="superf_terreno" name="superf_terreno" formControlName="superf_terreno" >
                                        <span matSuffix>m²</span>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-3">
                                    <label for="npisos" style="padding-bottom: 20px; padding-top: 15px;">Nro de pisos</label>
                                </div>
                                <div class="col-md-3">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Nro de pisos" id="npisos" name="npisos" formControlName="npisos" >
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="form-group" style="padding-top: 20px;">
                                <div class="col-md-2"></div>
                                <div class="col-md-5" align="right">
                                    <button mat-raised-button color="primary" style="padding-top: 5px" id="ingreso_antecedentes" (click)="add_antecedentes_edif()">
                                                Agregar Antecedentes
                                            <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                        </button>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="datatable_antecedentes">
                        <ngx-datatable class="material expandable" [messages]="''" [rows]="rows" [columnMode]="'force'" [headerHeight]="'auto'" [footerHeight]="'auto'" [rowHeight]="'auto'">
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>EDIF ANTIGUA</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    <strong *ngIf="row.edificacion_antigua == 'SI'">Si</strong>
                                    <strong *ngIf="row.edificacion_antigua == 'NO'">No</strong>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>AMPL. ANTIGUA</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    <strong *ngIf="row.ampliacion_antigua == 'SI'">Si</strong>
                                    <strong *ngIf="row.ampliacion_antigua == 'NO'">No</strong>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>DESTINO</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.destino}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>SUPERF. TOTAL</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.superf_total}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>SUPERF. TERRENO</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.superf_terreno}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>OPCIONES</span>
                                </ng-template>
                                <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                    <span (click)="get_antecedentes_edif(rowIndex)" style="padding-right: 5px;"><i class="glyphicon glyphicon-pencil"></i></span>
                                    <span (click)="delete_antecedentes_edif(rowIndex)"><i class="glyphicon glyphicon-trash"></i></span>
                                </ng-template>
                            </ngx-datatable-column>
                        </ngx-datatable>
                    </div>
                </div>
            </div>
        </div>
    </fieldset>
    <ng-template #openModal>
        <h2 mat-dialog-title>Ingresar informaci&oacute;n de los Antecedentes</h2>
        <mat-dialog-content>
            <div class="form-horizontal">
                <div class="alert alert-info" role="alert">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <strong> Debe ingresar la informacion solicitada</strong>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="tipo">Solicitud trata de la regularizacion de Toda la Edificacion Antigua</label>
                    <div class="col-md-2">
                        <input id="id" name="id" type="hidden" placeholder="id" class="form-control input-md" [(ngModel)]="temp_ant.id">
                        <label style="padding-right: 20px"><input style="width: 21px" type="radio"  name="edificacion_antigua" value="SI" [(ngModel)]="temp_ant.edificacion_antigua" class="form-control input-md"/>SI</label>
                    </div>
                    <div class="col-md-2">
                        <label style="padding-right: 20px"><input type="radio"  name="edificacion_antigua" value="NO" [(ngModel)]="temp_ant.edificacion_antigua" class="form-control input-md"/>NO</label>
                    </div>

                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="tipo">Solicitud trata de la regularizacion de una Ampliacion Antigua</label>
                    <div class="col-md-2">
                        <label><input style="width: 21px" id="ampliacion_antigua" name="ampliacion_antigua" type="radio" placeholder="ampliacion_antigua" value="SI" class="form-control input-md" [(ngModel)]="temp_ant.ampliacion_antigua">SI</label>
                    </div>
                    <div class="col-md-2">
                        <label><input id="ampliacion_antigua" name="ampliacion_antigua" type="radio" placeholder="ampliacion_antigua" value="NO" class="form-control input-md" [(ngModel)]="temp_ant.ampliacion_antigua">NO</label>
                    </div>

                </div>
                <div class="form-group">
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="permiso">Destino</label>
                    <div class="col-md-6">
                        <input id="destino" name="destino" type="text" placeholder="destino" class="form-control input-md" [(ngModel)]="temp_ant.destino">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="superf_total">Superficie Total</label>
                    <div class="col-md-6">
                        <input id="superf_total" name="superf_total" type="superf_total" placeholder="superf_total" class="form-control input-md" [(ngModel)]="temp_ant.superf_total">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="superf_terreno">Superficie Terreno</label>
                    <div class="col-md-6">
                        <input id="superf_terreno" name="superf_terreno" type="superf_terreno" placeholder="superf_terreno" class="form-control input-md" [(ngModel)]="temp_ant.superf_terreno">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="npisos">Nro Pisos</label>
                    <div class="col-md-6">
                        <input id="npisos" name="npisos" type="text" placeholder="npisos" class="form-control input-md" [(ngModel)]="temp_ant.npisos">
                    </div>
                    <div class="col-md-2"></div>
                </div>
            </div>

        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_antecedentes_edif" data-dismiss="modal" (click)="cleanData()">Cancelar</button>
            <button mat-raised-button color="primary" id=" ingreso_antecedente_edif" (click)="saveAntecedentes_edif() ">Ingresar Antecedentes <i class="fa fa-user-o " aria-hidden="true "></i></button>

        </mat-dialog-actions>
    </ng-template>
</div>

<ng-template #openModalNODATA>
    <h2 mat-dialog-title>Ingrese datos</h2>
    <mat-dialog-content>
       No ingreso ningun dato de los Antecedentes.
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal" (click)="cleanData()">Aceptar</button>
    </mat-dialog-actions>
</ng-template>


<div class="separator"></div>